import { useEffect, useState } from "react";
import Header from "../components/Header";
import axios from "@/shared/config/axios-interceptor";
import { formatMoney } from "@/shared/utils/ultils";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const GhiChepDauTu = () => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  const [listData, setListData] = useState<any>([]);
  const getData = async () => {
    try {
      const res = await axios.get("/transaction/ghi-chep-dau-tu?limit=50");
      setListData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const renderType = (type: number) => {
    switch (type) {
      case 1:
        return <span>{t("Nạp")}</span>;
      case 2:
        return <span>{t("Rút")}</span>;
      case 3:
        return <span>{t("Gửi tiết kiệm")}</span>;
      case 4:
        return <span>{t("Phát sinh lợi nhuận")}</span>;
      case 5:
        return <span>{t("Thưởng")}</span>;
      default:
        return <span>{t("Nạp")}</span>;
    }
  };
  return (
    <div className="wrapper">
      <div className="container-web gioithieusanpham bgnew">
        <Header title={t("Ghi chép đầu tư")} />

        <main style={{ fontSize: 12 }}>
          {listData?.length == 0 && (
            <div className="p-5 text-center" style={{ fontSize: 14 }}>
              {t("Không có dữ liệu")}
            </div>
          )}
          {listData?.map((item: any, index: number) => {
            return (
              <div
                key={index}
                className="px-3 py-2"
                style={{ borderBottom: "1px solid #333" }}
              >
                <div className="d-flex justify-content-between fw-bold">
                  <span>{renderType(item.type)}</span>
                  <span style={{ color: "#d5b377" }}>
                    {formatMoney(item.money)}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>
                    {dayjs(item.createdDate).format("DD/MM/YYYY HH:mm:ss")}
                  </span>
                  <span>{t(item.description)}</span>
                </div>
              </div>
            );
          })}
        </main>
      </div>
    </div>
  );
};

export default GhiChepDauTu;
